/* eslint-disable no-undef */
const constructResponseFields = function(data) {
  const response = [];
  data.fields.forEach(function(field) {
    response.push({
      internal_name: field.internal_name,
      display_name: field.display_name,
      value: field.meta?.read_only_value ?? '',
      value_display_text: '',
      field_type: field.field_type,
      type: field.type,
      previous_response: field.previous_response
    });
  });
  return response;
};

const isModelMarkedTrue = function(model) {
  const filtered = Object.keys(model).filter(function(k){
    return model[k];
  });
  return filtered.length > 0;
};

app.component('payerExpertiseForm', {
  templateUrl: '/components/payer-expertise/payer_expertise_form.component.58d85f73.html',
  controllerAs: '$ctrl',
  controller:
  ['$timeout', '$http', 'HttpAuth', 'apiHelper', '$routeParams', 'portalHelper',
    'authHelper', '$compile', '$scope', 'CONSTANTS', '$filter',
    function ($timeout, $http, HttpAuth, apiHelper, $routeParams, portalHelper,
      authHelper, $compile, $scope, CONSTANTS, $filter) {
      const component = this;
      component.showNextButton = false;
      component.pageNumber = 1;
      component.CONSTANTS = CONSTANTS;
      component.validation_errors = [];

      // This will contain responses of all pages, index representing the pageNumber
      component.responsesAcrossPages = [];
      component.questionsAcrossPages = {};
      component.responseObject = {};
      component.existingPayer = $routeParams.existingPayer;
      component.mat_date_popup = {
        dateCalOpen: false
      };
      component.openDatePicker = function () {
        component.mat_date_popup.dateCalOpen = true;
      };
      component.dateOptions = {
        datepickerMode: 'month',
        minMode: 'month',
        maxDate: new Date(),
        showWeeks: false
      };

      component.dependentQuestionBanner = '';
      const dateTypeFields = [
        'date', 'month_year'
      ];

      const isDateTypeField = function (element) {
        const allQuestions = component.questionsAcrossPages[component.pageNumber].fields;
        const question = _.filter(allQuestions,
          function (item) {
            return item.internal_name === element.internal_name &&
            dateTypeFields.indexOf(item.field_type) !== -1;
          }
        );

        return question.length;
      };

      const getQuestionIndexOffset = function (pageNumber) {
        if (pageNumber) {
          let countOfQuestions = 0;
          for (let i = 0; i < pageNumber; i++){
            countOfQuestions += component.questionsAcrossPages[i]?.fields?.length ?? 0;
          }
          return countOfQuestions;
        }
        return 0;
      };

      const isOptionForPreviousResponsePresent = function(options, value, field_type) {
        let flag = true;
        if (field_type === 'checkbox' || field_type === 'multi_select') {
          value.split(';').forEach((val) => {
            if (_.findIndex(options, {'internal_name': val}) === -1) {
              flag = false;
            }
          });
          return flag;
        }
        if (_.findIndex(options, {'internal_name': value}) === -1) {
          return false;
        }
        return true;
      };

      component.check_max_length = function(field, value) {
        if (field.meta && field.meta.max_length) {
          if (value.length > field.meta.max_length) {
            return true;
          }
          angular.element('#input_' + field.internal_name).removeClass('ng-invalid');
        }

        return false;
      };

      component.getQuestionNumber = function (index) {
        return getQuestionIndexOffset(component.pageNumber) + index + 1;
      };

      component.getYearsRange = function() {
        return _.range(new Date().getFullYear(), new Date().getFullYear() - 100);
      };

      component.getPayerExpertiseForm = function (formType) {
        const url = apiHelper.getApiUrl() + '/api/payer_form/' + $routeParams.formId + '/?token=' + $routeParams.token;

        // For AUTHENTICATED USER, we use HttpAuth
        if ($routeParams.existingPayer === 'true') {
          return HttpAuth.post(url);
        }

        /** FOR NON-AUTHENTICATED USERS
         * We have not used our custom HttpAuth service for post requests here because
         * This is going to be a public page and this form can be filled by a non-authenticated user
         * Only validation of token would take place at the API level to make sure that the form
         * is being filled by one of our generated links.
         *  */
        return $http.post(url);
      };

      const formIdentifier = $routeParams.token;
      const payerId = $routeParams.payerId || 'potential_payer';
      const LOCAL_STORAGE_KEY_PREFIX = 'payerId:' + payerId + '_formId:' + $routeParams.formId + '_token:' + formIdentifier;
      const get_localstorage_key = function () {
        return LOCAL_STORAGE_KEY_PREFIX;
      };

      /**
       * @description This function is used to get the model for multi_select and checkbox fields
       * while prepopulating form with earlier responses, with out setting the model fields will
       * not be prepopulated in the table
       *
       * @param {record} record for which model has to be fetched
       * @returns {object} model for the record
       */
      const retrieveSingleFieldModel = function(record) {
        const retriveModel = {
          'checkbox' : function() {
            const values = record.previous_response.split(';');
            const question =  _.find(component.questionsAcrossPages[component.pageNumber].fields, {'internal_name': record.internal_name});
            // some times values are not sorted in the list as per their display_order
            const options = _.sortBy(question.options, 'display_order');
            const model = {};
            for (let i = 0; i < values.length; ++i) {
              const index = _.findIndex(options, {'internal_name': values[i]});
              if (-1 != index) {
                model[index] = true;
              }
            }
            return model;
          },
          'multi_select' : function() {
            const values = record.previous_response.split(';');
            const question =  _.find(component.questionsAcrossPages[component.pageNumber].fields, {'internal_name': record.internal_name});
            // some times values are not sorted in the list as per their display_order
            const options = _.sortBy(question.options, 'display_order');
            const model = [];
            for (let i = 0; i < values.length; ++i) {
              const index = _.findIndex(options, {'internal_name': values[i]});
              if (-1 != index) {
                model.push({
                  'display_name' : options[index].display_name,
                  'display_order': options[index].display_order,
                  'internal_name': options[index].internal_name
                });
              }
            }
            return model;
          }
        };

        return retriveModel[record.field_type]();
      };
      /**
       * @param {*} keyPrefix This is used to identify for which page, the record field is being saved.
       *                    This can be retrieved using the function get_localstorage_key
       * @param {*} record This is the field whose value need to be retrieved from localstorage and updated
       *                    into corresponding properties.
       */
      const retrieveSingleField = function (keyPrefix, record) {
        const data = localStorage.getItem(keyPrefix + '_' + record.internal_name);
        let value;
        let isModelValid = true;
        if (!data) {
          if (record.previous_response) {
            value = record.previous_response;
            if (record.field_type === 'month_year') {
              // At the time of this writing Chrome supports new Date("mmm YYYY") but firefox don't.
              // So, We are concatenating '01' to month year string so that it can be used to create
              // a valid date object across browsers, later without any error
              value = '01 ' + value;
            }
          } else {
            return;
          }
        } else {
          value = JSON.parse(data);
        }

        // Since telephone input is a custom component it has to be persisted in a different way
        if (record.internal_name in component.telInputHandles) {
          const inputHandle = component.telInputHandles[record.internal_name];
          inputHandle.set_number(value);
          record.value = value;
          return;
        }

        if (isDateTypeField(record)) {
          record.value = new Date(value);
        }
        else {
          if (record.type === 'enumeration') {
            // sometimes the questions can be same, but the options can be different inside them. (e.g in case if payer changes country of expertise on previous page)
            const options = component.questionsAcrossPages[component.pageNumber].fields
              .filter((field) => field.internal_name === record.internal_name)[0].options;
            // incase the options are different, we set the value to null. This ensures that the user has to select the response again.
            record.value = isOptionForPreviousResponsePresent(options, value, record.field_type) ? value : null;
            isModelValid = record.value !== null;
          } else {
            record.value = value;
          }
        }
        // in case that options have changed, the persisted model is no longer valid.
        if (isModelValid) {
          const model_data = localStorage.getItem(keyPrefix + '_' + record.internal_name + '_model');
          if (model_data) {
            record.model = JSON.parse(model_data);
          } else if (record.previous_response &&
              (record.field_type == 'checkbox' || record.field_type == 'multi_select')) {
          // if model is not defined, and value in there in the previous_response means we have to prepopulate the
          // form and for multi_select and checkbox type fields model need to set in record only setting value will
          // not work
            record.model = retrieveSingleFieldModel(record);
          }
        }
      };

      /**
       * @param {*} keyPrefix  This is used to identify for which page, the field record is being saved.
       *                    This can be retrieved using the function get_localstorage_key
       * @param {*} record This is the field whose value needs to be persisted in localstorage.
       */
      const persistSingleField = function (keyPrefix, record) {

        // Telephone inputs are custom fields, so persisted in a little different way
        if (record.internal_name in component.telInputHandles) {
          const inputHandle = component.telInputHandles[record.internal_name];
          if (inputHandle.is_valid_number()) {
            //get_number expects a valid number, and so should only be used after validation.
            record.value = inputHandle.get_number();
          }
          if (record.value) {
            localStorage.setItem(
              keyPrefix + '_' + record.internal_name,
              JSON.stringify(record.value)
            );
          }
          return;
        }

        if (record.value) {
          localStorage.setItem(
            keyPrefix + '_' + record.internal_name,
            JSON.stringify(record.value)
          );
        }
        if (record.model) {
          localStorage.setItem(
            keyPrefix + '_' + record.internal_name + '_model',
            JSON.stringify(record.model)
          );
        }
      };

      const formatDateToMonthYear = function(dateObj) {
        return $filter('date')(dateObj, CONSTANTS.dateTimeFormat.MEDIUM_ONLY_MONTH_YEAR);
      };

      const prepopulateFields = function (responseFields) {
        if (component.existingPayer === 'true') {
          component.me = authHelper.getMeShared();
          for (let i = 0; i < responseFields.length; i++) {
            if (responseFields[i].internal_name === 'firstname') {
              responseFields[i].value = component.me.first_name;
            }
            if (responseFields[i].internal_name === 'lastname') {
              responseFields[i].value = component.me.last_name;
            }
            if (responseFields[i].internal_name === 'email') {
              responseFields[i].value = component.me.email;
            }
          }
        }
      };

      const attachValueDisplayTextToEachResponse = function (responses, pageNumber) {
        let allQuestions = [];
        for (let i = 0; i < pageNumber; i++) {
          allQuestions = allQuestions.concat(component.questionsAcrossPages[i].fields);
        }
        const copyOfResponses = angular.copy(responses);
        _.map(copyOfResponses, function (element) {
          // in case of question where value is not present, and field is not a required field, we intialize value as empty string so value.split() does not throw error
          element.value = element.value || '' ;

          const question = _.find(allQuestions, {'internal_name': element.internal_name});
          if (question.options.length) {
            if (question.field_type === 'checkbox' || question.field_type === 'multi_select') {
              const values = element.value.split(';');
              const selectedOptions = _.filter(question.options, function (option) {
                return values.indexOf(option.internal_name) !== -1;
              });
              const display_text_values = _.pluck(selectedOptions, 'display_name');
              element.value_display_text = JSON.stringify(display_text_values);
            }
            else {
              const selectedOption = _.find(question.options, {'internal_name': element.value});
              element.value_display_text = selectedOption ? selectedOption.display_name : '';
            }
          } else  {
            if (question.field_type === 'month_year') {
              element.value_display_text = element.value ? formatDateToMonthYear(new Date(element.value)) : '';
            } else {
              element.value_display_text = element.value;
            }
          }
          return element;
        });
        return copyOfResponses;
      };

      /**
       * @description We call this method when we navigate to a new page using next or back button
       * This function will traverse all the fields in responseFields and save their values in localstorage.
       */
      const fetchAlreadySavedData = function (event) {
        // get and parse the saved data from localStorage
        $timeout(
          function () {
            const keyPrefix = get_localstorage_key();
            component.responseFields.map(
              function (record) {
                return retrieveSingleField(keyPrefix, record);
              }
            );
          }
        );
      };

      /**
       * @param {*} event This can be used to pass any data to resolve method.
       * @returns a promise, which will be resolved after (saving all the responseFields to localstorage
       * and digest loop of angularjs has been fired).
       * @description We are saving each field with a separate key because the fields on expertise-forms are dynamic.
       * What fields on a page will be displayed depends on (what values were chosen on the previous page).
       * Saving fields in a chunk for each page is problematic because the fields on page will keep on changing depending
       * upon the values chosen on previous page. Further, back and next navigation can change a page's fields multiple times.
       * So, We stored an retrieved the data on field level to avoid such issues.
       */
      const saveResponsesToLocalStorage = function(event) {
        const keyPrefix = get_localstorage_key();
        return new Promise(function(resolve) {
          $timeout(
            function () {
              component.responseFields.forEach(function (record) {
                persistSingleField(keyPrefix, record);
              });
              resolve(event);
            }
          );

        });
      };

      const initializeAllTelephoneInputs = function () {
        const telInputs = _.filter(
          component.questionsAcrossPages[component.pageNumber].fields,
          {field_type: 'mobile'}
        );
        component.telInputHandles = [];
        for (let i = 0; i < telInputs.length; i++) {
          const selector = '#input_' + telInputs[i].internal_name;
          const elem = angular.element(selector);
          if (elem) {
            const inputHandle = portalHelper.initializeTelephoneInput(selector);
            component.telInputHandles[telInputs[i].internal_name] = inputHandle;
            elem.on('countrychange change', function (e) {
              // required to remove validation errors on change if any
              if (elem.hasClass('ng-invalid')) {
                if (inputHandle.is_valid_number()) {
                  elem.removeClass('ng-invalid');
                  elem.removeClass('is-invalid');
                  $timeout(() => component.validation_errors[telInputs[i].internal_name] = null);
                }
              }
            });
          }
        }
      };

      const initiateAutoSave = function () {
        angular.element(document).ready(
          function () {
            initializeAllTelephoneInputs();

            // Fetch the already saved data first
            fetchAlreadySavedData();
          }
        );

        window.onbeforeunload = component.constructAndPersistResponses;

      };

      component.$onInit = function() {
        component.isLoading = true;
        component.getPayerExpertiseForm({formType: component.formType})
          .then(function(result) {
            $timeout(function() {
              const data = result.data;
              data.fields = _.sortBy(data.fields, 'display_order');
              component.formTitle = data.form_name;
              if (data.form_description) {
                component.formDescription = data.form_description;
              }
              component.pageNumber = 0;
              component.responseFields = constructResponseFields(data);
              component.questionsAcrossPages[component.pageNumber] = data;
              component.showNextButton = component.shouldShowNextButton(data);
              component.responseObject = {'response':component.responseFields };
              prepopulateFields(component.responseFields);
              initiateAutoSave();
            });
          })
          .catch(function(err) {
            // if form submitted show submission status
            if ((err.status === 401 || err.status === 403) && err.data.detail === 'Token has been used.') {
              component.isFormAlreadySubmitted = true;
            } else if (err.status === 403 && err.data.detail === 'Invalid Token.') {
              component.isTokenInvalid = true;
            } else {
              portalHelper.showErrorCommon(err);
              component.hasFormErrored = true;
            }
          })
          .finally(function() {
            component.isLoading = false;
          });
      };
      component.shouldShowNextButton = function(formData) {
        const dependentFields = formData.fields.filter(function(field) {
          return field.has_dependent_fields;
        });
        return dependentFields.length > 0 ? true : false;
      };

      component.getNextQuestionSet = function(responseArray, sectionNumber) {
        const url = apiHelper.getApiUrl() + '/api/payer_form/' + $routeParams.formId + '/?token=' + $routeParams.token + '&section_number=' + sectionNumber;
        const data = {'response': responseArray};

        /**
         * FORM SUBMISSION BY - AUTHENTICATED USERS
         */
        if ($routeParams.existingPayer === 'true') {
          return HttpAuth.post(url, data);
        }

        /**
         * FORM SUBMISSION BY - NON-AUTHENTICATED USERS
         * We have not used our custom HttpAuth service for post requests here because
         * This is going to be a public page and this form can be filled by a non-authenticated user.
         * Only validation of token would take place at the API level to make sure that the form
         * is being filled by one of our generated links.
         *  */
        return $http.post(url, data);
      };

      component.submitForm = function(responseArray, sectionNumber) {
        const url = apiHelper.getApiUrl() + '/api/payer_form/' + $routeParams.formId + '/submit' + '/?token=' + $routeParams.token + '&section_number=' + sectionNumber;
        const data = {'response': responseArray};

        /**
         * FORM SUBMISSION BY - AUTHENTICATED USERS
         */
        if ($routeParams.existingPayer === 'true') {
          return HttpAuth.post(url, data);
        }

        /**
         * FORM SUBMISSION BY - NON-AUTHENTICATED USERS
         * We have not used our custom HttpAuth service for post requests here because
         * This is going to be a public page and this form can be filled by a non-authenticated user
         * Only validation of token would take place at the API level to make sure that the form
         * is being filled by one of our generated links.
         *  */
        return $http.post(url, data);
      };

      component.isFieldInvalid = function(payerForm, field) {

        if (field) {
          if (payerForm[field.internal_name].$error.required && payerForm[field.internal_name].$submitted && payerForm[field.internal_name].$untouched) {
            return true;
          }
          if (payerForm[field.internal_name].$error.required && payerForm[field.internal_name].$touched && payerForm[field.internal_name].$invalid) {
            return true;
          }
        }
        return false;
      };
      component.isNumFieldInvalid = function(payerForm, field, index) {
        if (component.isFieldInvalid(payerForm, field)) {
          return true;
        } else if (field.meta && component.responseFields[index] &&(field.meta.min_value > component.responseFields[index].value || field.meta.max_value < component.responseFields[index].value)) {
          return true;
        }
        return false;
      };

      component.isAnyCheckboxClicked = function(model) {
        if (model && isModelMarkedTrue(model)) {
          return true;
        }
        return false;
      };

      component.constructCheckboxResponse = function() {
        const checkboxIndices =
        component.questionsAcrossPages[component.pageNumber].fields.map(function(field, i) {
          return field.field_type==='checkbox' ? i : -1;
        })
          .filter(function(index) {
            return index !==-1;
          });
        checkboxIndices.map(function(i) {
          const checkboxResponseField = component.responseFields[i];
          if (!checkboxResponseField.model) {
            return;
          }
          const markedOptions = Object.keys(checkboxResponseField.model);
          const markedTrueOptions = markedOptions.filter(function(key) {
            return checkboxResponseField.model[key];
          });
          // clear out value field in case it was previously filled
          component.responseFields[i].value = '';
          let options = component.questionsAcrossPages[component.pageNumber].fields[i].options;
          options =  _.sortBy(options, 'display_order');

          markedTrueOptions.forEach(function(optionIndex) {
            component.responseFields[i].value = component.responseFields[i].value + options[optionIndex].internal_name + ';';
          });
          // remove last semicolon
          component.responseFields[i].value = component.responseFields[i].value.slice(0, -1);
        });
      };
      component.constructMultiSelectResponse = function() {
        const multiSelectQuestionIndices =
        _.map(component.questionsAcrossPages[component.pageNumber].fields, function(field, i) {
          return field.field_type==='multi_select' ? i : -1;
        })
          .filter(function(index) {
            return index !== -1;
          });

        _.map(multiSelectQuestionIndices, function(questionIndex) {

          // clear out value field in case it was previously filled
          component.responseFields[questionIndex].value = '';

          const multiSelectField = component.responseFields[questionIndex];
          _.map(multiSelectField.model, function(tags) {
            component.responseFields[questionIndex].value = component.responseFields[questionIndex].value + tags.internal_name + ';';
          });
          // remove last semicolon
          component.responseFields[questionIndex].value = component.responseFields[questionIndex].value.slice(0, -1);
        });
      };

      function adjustMonthYearFields(responsesWithValueDisplayText, pageNumber) {
        const responsesCopy = angular.copy(responsesWithValueDisplayText);
        for (let i = 0; i < pageNumber; i++) {
          const monthYearQuestionIndicesOnPage =
          _.map(component.questionsAcrossPages[i].fields, function(field, index) {
            return field.field_type==='month_year' ? index : -1;
          })
            .filter(function(index) {
              return index !== -1;
            });
          _.map(monthYearQuestionIndicesOnPage, function(questionIndex) {
            const monthYearQuestionIndex = getQuestionIndexOffset(i) + questionIndex;
            const dateObj = new Date(responsesCopy[monthYearQuestionIndex].value);
            responsesCopy[monthYearQuestionIndex].value = isNaN(dateObj) ? '' : formatDateToMonthYear(dateObj);
          });
        }
        return responsesCopy;
      }

      component.onBackClick = function() {
        component.processingBackButton = true;
        component.constructAndPersistResponses().then(
          function () {
            component.pageNumber = component.pageNumber - 1;
            component.responseFields = component.responsesAcrossPages[component.pageNumber];
            component.showNextButton = true;
            component.responseObject = {'response':component.responseFields };
            component.validateUSFormForDependentQuestionBanner();
          }
        ).finally(
          function () {
            $timeout(
              function () {
                component.processingBackButton = false;
                $timeout(
                  function () {
                    // While navigating between pages, telephone inputs need to be initialized again
                    initializeAllTelephoneInputs();
                    const keyPrefix = get_localstorage_key();
                    const mobile_records = _.filter(
                      component.questionsAcrossPages[component.pageNumber].fields,
                      {field_type: 'mobile'}
                    );
                    for (let index = 0; index < mobile_records.length; index++) {
                      const record = mobile_records[index];
                      retrieveSingleField(keyPrefix, record);
                    }
                  }
                );
              }
            );
          }
        );
      };

      const highlightInvalidElement = function (invalidElement) {
        $(invalidElement).addClass('border-glow-animation');
        invalidElement.scrollIntoView({behavior: 'smooth', block: 'center', inline: 'nearest'});
      };

      const getFirstInvalidElement = function () {

        // Custom validation for multi_select widget
        const allFields = component.questionsAcrossPages[component.pageNumber].fields;

        // Traverse all fields to find any errors with custom widgets.
        _.map(allFields, function (item) {

          // For multi-select type questions, if it's a mandatory field
          let invalidElement;
          if (item.field_type === 'multi_select' && item.is_required) {
            // Remove any error classes to begin with, apply error class only if response is not found.
            angular.element('#input_' + item.internal_name).removeClass('ng-invalid');

            const response = _.filter(component.responseFields, function (response) {
              if (!response.model) {
                return false;
              }
              return response.internal_name === item.internal_name && response.model.length > 0;
            });
            // If a response is present, don't show any kind of error
            if (response.length > 0) {
              return;
            }
            invalidElement = angular.element('#input_' + item.internal_name);
            invalidElement.addClass('ng-invalid');
          } else if ('mobile' === item.field_type) {
            invalidElement = angular.element('#input_' + item.internal_name);
            if (authHelper.isUserAdmin() && !invalidElement.value) {
              // in case its not filled and admin is editing this skip the validations
              return;
            }
            const isValidNumber = component.telInputHandles[item.internal_name].is_valid_number();
            if (isValidNumber) {
              invalidElement.removeClass('ng-invalid');
              component.validation_errors[item.internal_name] = null;
            } else {
              const error = component.telInputHandles[item.internal_name].get_validation_error();
              $timeout(() => component.validation_errors[item.internal_name] = error);
              invalidElement.addClass('ng-invalid');
            }
          } else if (item.meta && item.meta.max_length) {
            const element = angular.element('#input_' + item.internal_name);
            if (element[0].value.length > item.meta.max_length) {
              element.addClass('ng-invalid');
            }
          }
        });

        const elements = angular.element('[name=\'' + component.payerForm.$name + '\']');
        const invalidElement = $(elements.find('.ng-invalid:first'))[0];
        return invalidElement;
      };

      component.onMultiSelectTagAdded = function(field) {
        angular.element('#input_' + field.internal_name).removeClass('ng-invalid');
      };

      component.removeInvalidClass = function(field) {
        angular.element(
          '#input_' + field.internal_name
        ).removeClass('is-invalid');
        angular.element(
          '#container_' + field.internal_name + ' input'
        ).removeClass('is-invalid');
      };

      component.onNextClick = function() {
        component.constructAndPersistResponses().then(
          function () {
            // debugger;
            const invalidElement = getFirstInvalidElement();
            if (invalidElement) {
              highlightInvalidElement(invalidElement);
              return;
            }


            // Not setting processingNextButton as true as the first line of function because,
            // We will need to set it to false if validation fails. It's simpler to do it here.
            component.processingNextButton = true;
            component.responsesAcrossPages[component.pageNumber] = component.responseFields;
            component.pageNumber = component.pageNumber + 1;
            const responseArr = component.mergeResponse(
              component.responsesAcrossPages,
              component.pageNumber
            );
            const responsesWithValueDisplayText = attachValueDisplayTextToEachResponse(
              responseArr,
              component.pageNumber
            );
            const adjustedResponses = adjustMonthYearFields(responsesWithValueDisplayText, component.pageNumber - 1);
            component.getNextQuestionSet(adjustedResponses, component.pageNumber + 1)
              .then(function(result) {
                $timeout(function() {
                  const data = result.data;
                  data.fields = _.sortBy(data.fields, 'display_order');
                  component.payerForm.$setPristine();
                  component.payerForm.$setUntouched();
                  component.questionsAcrossPages[component.pageNumber] = data;
                  component.responseFields = constructResponseFields(data);
                  component.showNextButton = component.shouldShowNextButton(data);
                  component.responseObject = {'response': responseArr };
                  fetchAlreadySavedData();
                  component.validateUSFormForDependentQuestionBanner();
                });
              })
              .catch(function(err) {
                component.pageNumber = component.pageNumber - 1;
                portalHelper.showErrorCommon(err);
              })
              .finally(function() {
                component.processingNextButton = false;
              });
          }
        );
      };

      component.showTextTypeField = function (fieldType) {
        return (fieldType==='text' || fieldType==='email');
      };

      component.mergeResponse = function(responsesAcrossPages, numberOfPages) {
        let responseArr = [];
        for (let i = 0; i < numberOfPages; i++) {
          responseArr = responseArr.concat(responsesAcrossPages[i]);
        }
        return responseArr;
      };

      component.onSubmitClick = function($event) {
        // some feilds are not saved on change so trigger a call to save all the fields
        // in local storage
        component.constructAndPersistResponses();
        const invalidElement = getFirstInvalidElement();
        if (invalidElement) {
          highlightInvalidElement(invalidElement);
          return;
        }
        component.isSubmitting = true;
        component.responsesAcrossPages[component.pageNumber] = component.responseFields;
        component.pageNumber = component.pageNumber + 1;
        const responseArr = component.mergeResponse(
          component.responsesAcrossPages,
          component.responsesAcrossPages.length
        );
        const responsesWithValueDisplayText = attachValueDisplayTextToEachResponse(
          responseArr,
          component.pageNumber
        );
        const adjustedResponses = adjustMonthYearFields(responsesWithValueDisplayText, component.pageNumber - 1);
        component.submitForm(adjustedResponses  , component.pageNumber + 1)
          .then(function() {
            component.isFormSubmittedSuccessfully = true;
          })
          .catch(function(err) {
            if (err.status === 403 && err.data.detail === 'Token has been used.')
              component.isFormAlreadySubmitted = true;
          })
          .finally(function() {
            component.isSubmitting = false;
            component.pageNumber = component.pageNumber - 1;
          });
      };

      component.isPrePopulatedField = function (field) {
        if (component.existingPayer === 'false') {
          return false;
        }
        const isPrePopulated = ['firstname', 'lastname', 'email'].indexOf(field.internal_name) != -1;
        return isPrePopulated;
      };

      component.searchFilteredList = function (data, query) {
        const options = _.sortBy(data, 'display_order');
        return !query
          ? options
          : _.filter(options, function (elem) {
            return elem.display_name.toLowerCase().indexOf(query.toLowerCase()) >= 0;
          });
      };

      /**
       * This function is used to construct values for checkboxes and multi_select fields
       * so that we save correct values in the local storage, for such fields by default
       * model is updated on change but value field is not.
       * @returns {promise} proimse object of saveResponsestoLocalStorage
       */
      component.constructAndPersistResponses = function () {
        component.constructCheckboxResponse();
        component.constructMultiSelectResponse();
        return saveResponsesToLocalStorage();
      };

      /**
       * This function is used to validate USExpertise From when admin is editing
       * if all the questions on previous page on which there are dependent question is
       * answered, if not answered then show a text saying which question on previous
       * page is not answered.
       */
      component.validateUSFormForDependentQuestionBanner = function () {
        let bannerText = '';
        // if user is not admin and form is not US Expertise form
        // do nothing
        if (!(authHelper.isUserAdmin() && 2 == $routeParams.formId)) {
          component.dependentQuestionBanner = bannerText;
          return;
        }

        let index;
        // all questions on page 2 are dependent on payer_type
        if (1 === component.pageNumber && 0 === component.questionsAcrossPages[1].fields.length) {
          index = component.questionsAcrossPages[0].fields.findIndex(field => field.internal_name === 'payer_type');
          if (index != -1) {
            bannerText = 'Questions on this page will be displayed only if Question '
            + (index + 1) + ' on the previous page has a response.';
          }
        }

        // questions on page 3 are dependent on the us_organization type on page 2
        if (2 === component.pageNumber) {
          index = component.questionsAcrossPages[1].fields.findIndex(field => field.internal_name === 'us_organization_type');
          // calculate count of questions on page 1 to show correct question number
          const firstPageQuestionCount = component.questionsAcrossPages[0].fields.length;
          if (index != -1 && !component.responsesAcrossPages[1][index].previous_response
             && !component.responsesAcrossPages[1][index].value) {
            bannerText = 'Questions on this page will be displayed only if Question '
            + (firstPageQuestionCount + index + 1) + ' on the previous page has a response.';
          }
        }
        component.dependentQuestionBanner = bannerText;
      };
    }]});

